import React, {useEffect} from 'react'
import { useLocation } from "react-router-dom";
import Footer from './Footer';

const CookiesPolicy = ({lang, translations}) => {

  const { pathname } = useLocation();
     useEffect(() => {
            window.scrollTo(0, 0); 
          }, [pathname]); 


  return (
    <div>
    <div className="cookies-page">
      <h2>{translations[lang].cookies1}</h2>

      <p>
        {translations[lang].cookies2}
      </p>

      <h3>{translations[lang].cookies3}</h3>
      <p>
        {translations[lang].cookies4}
      </p>

      <h3> {translations[lang].cookies5}</h3>
      <ul>
        <li>
          <strong>{translations[lang].cookies6}</strong> 
          {translations[lang].cookies7}
        </li>
        <li>
          <strong>{translations[lang].cookies8}</strong> 
          {translations[lang].cookies9}
        </li>
        <li>
          <strong>{translations[lang].cookies10}</strong> 
          {translations[lang].cookies11}
        </li>
      </ul>

      <h3>{translations[lang].cookies12}</h3>
      <p>
        {translations[lang].cookies13}
      </p>

      <h3>{translations[lang].cookies14}</h3>
      <p>
        {translations[lang].cookies15}
      </p>

      <h3>{translations[lang].cookies16}</h3>
      <p>
        {translations[lang].cookies17}
      </p>
      </div>
      <Footer lang={lang} translations={translations}/>
    </div>
    
  );
};

export default CookiesPolicy;
